import React from 'react';
import { Controller } from 'react-hook-form';
import PhoneNumberInputWithAnt from 'src/components/ui/PhoneNumberInputWithAnt';
import Span from 'src/components/ui/Span';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormPlaceholder, getFormInstructions } from 'src/helpers/multilingualHelper';

const PhoneNumberClientForm = ({ elementId, label, name, required, placeholder, control, errors, config, onChange, value }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayPlaceholder = getFormPlaceholder(placeholder, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);

    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className={`block ${config.hasInstructions ? '' : 'mb-2'} text-sm  text-gray-700`}>
                {displayLabel}{required && '*'}
            </label>
            {
                config.hasInstructions && <label className="mb-2 text-xs  text-gray-300">
                    {displayInstructions}
                </label>
            }
            <Controller
                name={name || elementId}
                control={control}
                rules={{
                    required: required,
                    pattern: {
                        value: /^\+\d[\d-]*$/,
                        message: t('form.phoneNumberFormat')
                    }
                }}
                render={({ field }) => {
                    if (!field.value && value) {
                        field.onChange(value);
                    }

                    return (
                        <PhoneNumberInputWithAnt
                            {...field}
                            ref={field.ref}
                            id={elementId}
                            placeholder={displayPlaceholder}
                            value={field.value || ''}
                            status={errors[elementId] ? "error" : ""}
                            onChange={(v) => {
                                field.onChange(v);
                                onChange && onChange(elementId, null, v);
                            }}
                        />
                    );
                }}
            />
            {errors[elementId] && (
                <Span className="text-FailRed400 text-xxs">
                    {errors[elementId].message ? errors[elementId].message : t('form.thisFieldRequired')}
                </Span>
            )}
        </div>
    );
};

export default PhoneNumberClientForm;
